<template>
  <div>
    <div class="row">
      <div class="item">
        <span class="label">{{ $t('seller.cpcCampaignInfoTab.labelTitle') }}</span>
        <span class="value">{{ detail.title }}</span>
      </div>
      <div class="item">
        <span class="label">{{ $t('seller.cpcCampaignInfoTab.labelCpc') }}</span>
        <div class="cpc-item">
          <div class="info-item-row">
            <div class="item-row">
              <img src="../../../../assets/images/img/AT@2x.png" alt="" class="icon" />
              <span class="item-text">Attribution</span>
            </div>
            <div class="info-item-row-value">
              {{ CURRENCY_DATA_MAPPER[detail.currency] }}{{ detail.attributionCpcUnitPrice }}
            </div>
          </div>
          <div class="info-item-row">
            <div class="item-row">
              <img src="../../../../assets/images/img/AS@2x.png" alt="" class="icon" />
              <span class="item-text">Associate</span>
            </div>
            <div class="info-item-row-value">
              {{ CURRENCY_DATA_MAPPER[detail.currency] }}{{ detail.associateCpcUnitPrice }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="item">
        <span class="label">{{ $t('seller.cpcCampaignInfoTab.labelTotalBudget') }}</span>
        <span class="value">{{ CURRENCY_DATA_MAPPER[detail.currency] }}{{ detail.totalBudget }}</span>
      </div>
      <div class="item">
        <span class="label">{{ $t('seller.cpcCampaignInfoTab.labelRemainingBudget') }}</span>
        <span class="value">{{ CURRENCY_DATA_MAPPER[detail.currency] }}{{ detail.budgetRemaining }}</span>
      </div>
    </div>
   
    <div class="row">
      <div class="item">
        <span class="label">{{ $t('seller.cpcCampaignInfoTab.labelTotalCapPerPublisher') }}</span>
        <span class="value">{{ CURRENCY_DATA_MAPPER[detail.currency] }}{{ detail.publisherTotalCap }}</span>
      </div>
      <div class="item">
        <span class="label">{{ $t('seller.cpcCampaignInfoTab.labelDailyCapPerPublisher') }}</span>
        <span class="value">{{ CURRENCY_DATA_MAPPER[detail.currency] }}{{ detail.publisherDailyCap }}</span>
      </div>
    </div>
    <div class="row">
      <div class="item" >
        <span class="label">{{ $t('seller.cpcCampaignInfoTab.labelDateRange') }}</span>
        <span class="value">{{ moment(detail.startDateTimestamp).tz(timeZone).format('YYYY.MM.DD') }} - {{ moment(detail.endDateTimestamp).tz(timeZone).format('YYYY.MM.DD') }}</span>
      </div>
      <div class="item" style="min-width: 33%;">
        <span class="label">{{ $t('seller.cpcCampaignInfoTab.labelAvailableLinkType') }}</span>
        <div class="cpc-item">
          <div class="info-item-row" v-if="detail.attributionCpcEnabled">
            <div class="item-row">
              <img src="../../../../assets/images/img/AT@2x.png" alt="" class="icon" />
              <span class="item-text">Attribution</span>
            </div>
          </div>
          <div class="info-item-row" v-if="detail.associateCpcEnabled">
            <div class="item-row">
              <img src="../../../../assets/images/img/AS@2x.png" alt="" class="icon" />
              <span class="item-text">Associate</span>
            </div>
          </div>
        </div>
      </div>
      <div class="item" >
        <span class="label">{{ $t('seller.cpcCampaignInfoTab.labelStatus') }}</span>
        <Status :type="statusType(detail.status)" :text="detail.status" :noBorder="true" />
      </div>
    </div>
    <!-- <div class="row">
      <div class="item">
        <span class="label">Status:</span>
        <Status :type="statusType(detail.status)" :text="detail.status" :noBorder="true" />
      </div>
      <div class="item">
        <span class="label">StartDate:</span>
        <span class="value">{{ moment(detail.startDateTimestamp).tz(timeZone).format('YYYY-MM-DD') }}</span>
        <span class="end-date-title">EndDate:</span>
        <span class="value">{{ moment(detail.endDateTimestamp).tz(timeZone).format('YYYY-MM-DD') }}</span>
      </div>
    </div>
    <div class="row">
      <div class="item wide">
        <span class="label">AvailableLinkType:</span>
        <span class="value">{{ returnLinkType(detail.availableLinkTypeLabels) }}</span>
      </div>
    </div> -->
  </div>
</template>

<script setup>
import { ref, onMounted, defineProps } from "vue"
import Status from "~/components/Status.vue"
import { sellerCpcApi } from "~/server"
import { useUserInfoStore } from "@/storeData"
import moment from "moment"

import { CURRENCY_MAPPER, COUNTRY_TIME_TZ, CURRENCY_DATA_MAPPER } from "@/contants/common"
const store = useUserInfoStore()
const userInfo = store.userInfo
const timeZone = COUNTRY_TIME_TZ[userInfo.countryCode] || 'US'
const props = defineProps({

  id: {
    type: String || Number,
    required: true,
  },
})
const detail = ref({})
onMounted(() => {

  sellerCpcApi.getCpcCampaignsById({ campaignId: props.id }).then(res => {

    detail.value = res.data
  })
})
const statusType = (status) => {
  if (status === "ACTIVE") return "active"
  if (status === "FINISHED") return "finished"
  return "inactive"
}
const returnLinkType = (linkType) => {
  if (Array.isArray(linkType)) {
    return linkType.map(item => item).join(',')
  } else {
    return '--'
  }
}
</script>

<style scoped lang="less">
.cpc-item {
  display: flex;
  align-items: center;
  gap: 10px;

  .item-row {
    display: flex;
    padding: 3px 4px;
    align-items: center;
    gap: 6px;
    border-radius: 6px;
    background: #f1f0f5;
    min-width: 111px;

    .icon {
      width: 20px !important;
      height: 20px !important;
    }

    .item-text {
      color: #0f0629;
      font-family: 'Sora';
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      letter-spacing: 0.3px;
      opacity: 0.7;
    }
  }

  .info-item-row {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .info-item-row-value {
    font-family: Sora;
    font-weight: 500;
    font-style: Medium;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 19px;
    letter-spacing: 0px;
    text-transform: uppercase;
    color: rgba(15, 6, 41, 1);
  }
}

.row {
  display: flex;
  gap: 30px;
  margin-bottom: 10px;
  margin: 30px 0;
}

.row:last-child {
  margin-bottom: 0;
}

.item {
  min-width: 45%;
  display: flex;

  flex-direction: column;
  flex-wrap: wrap;
  gap: 6px;
}

.item.wide {
  min-width: 100%;
}

.label {
  font-family: Sora;
  font-weight: 400;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0.3px;
  color: rgba(15, 6, 41, 0.5);
}

.value {
  font-family: Sora;
  font-weight: 600;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 20px;
  letter-spacing: 0.4px;
  color: rgba(15, 6, 41, 1);
}

.dot {
  // margin: 0 8px;
  color: #9ca3af;
}

.end-date-title {
  margin-left: 24px;
  color: #4b5563;
  font-weight: 600;
}
</style>
